import dynamic from 'next/dynamic';
import React from 'react';
import EvData from '~/components/ev/EvData';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import {
  StaticContextProvider,
  type OwnProps as StaticContextProps
} from '~/context/common/StaticContext';
import {
  UserContextProvider,
  type OwnProps as UserContextProps
} from '~/context/common/UserContext';

const CoreAuth = dynamic(
  () => import(/* webpackChunkName: "CoreAuth" */ '@/common/CoreAuth'),
  { ssr: false }
);

export type EvProvidersProps = {
  forDeviceContext: DeviceContextProps;
  forStaticContext: StaticContextProps;
  forUserContext: UserContextProps;
};

type OwnProps = React.PropsWithChildren<
  EvProvidersProps & {
    eventableProject: string;
    eventableTrack: string;
  }
>;

const EvProviders = ({
  children,
  eventableProject,
  eventableTrack,
  forDeviceContext,
  forStaticContext,
  forUserContext
}: OwnProps) => (
  <StaticContextProvider {...forStaticContext}>
    <AnalyticsProvider projectName={eventableProject} track={eventableTrack}>
      <DeviceContextProvider {...forDeviceContext}>
        <UserContextProvider {...forUserContext}>
          <CoreAuth />
          <EvData />
          {children}
        </UserContextProvider>
      </DeviceContextProvider>
    </AnalyticsProvider>
  </StaticContextProvider>
);

export default EvProviders;
